import React from "react";
import s from "./spacer.module.scss";

const Spacer = ({ size }) => {
  return size ? (
    <div className={s.spacer_size} />
  ) : (
    <div className={s.spacer} />
  );
};

export default Spacer;
